/** Слот расписания с полями, нужными для поиска ближайшего дня со свободными местами. */
type SlotWithPlaces = { places_left: number };

/**
 * Ближайший день после `afterDay` (ISO `YYYY-MM-DD`), в котором есть слот со свободными местами.
 * `byDate` — слоты, сгруппированные по дате; null, если таких дней в загруженном периоде нет.
 */
export function nextDayWithFreeSlots(
  byDate: ReadonlyMap<string, readonly SlotWithPlaces[]>,
  afterDay: string
): string | null {
  const days = [...byDate.keys()].filter((d) => d > afterDay).sort();
  for (const d of days) {
    if ((byDate.get(d) ?? []).some((s) => s.places_left > 0)) return d;
  }
  return null;
}

/** Сдвиг ленты дней так, чтобы `day` оказался в видимом окне из `visibleCount` дней. */
export function stripOffsetForDay(stripDays: readonly string[], day: string, visibleCount: number): number | null {
  const idx = stripDays.indexOf(day);
  if (idx < 0) return null;
  const maxOffset = Math.max(0, stripDays.length - visibleCount);
  return Math.min(idx, maxOffset);
}
